
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import GlobeZoom from './pages/GlobeZoom'
import AuthControl from './pages/AuthControl';
import PrivateRoutes from './components/utils/PrivateRoutes';
import ResetPassword from './components/login/ResetPassword';

function App() {
  return (
    <div className="App">
        <Router>
          <Routes>
            <Route element={<PrivateRoutes />}>
                <Route element={<GlobeZoom/>} path="/" />
            </Route>
            <Route element={<AuthControl/>} path="/login"/>
            <Route element={<ResetPassword/>} path="/ResetPassword/:reset_token"/>
          </Routes>
      </Router>
    </div>
  );
}

// function App(){

//   return(
//     <div> 
//       <GlobeZoom/>
//     </div>
//   )

// }

export default App;
